import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppMaterialModule } from '../../shared/appMaterial/app-material.module';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../shared/shared.module';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { IndependentContractorAgreementComponent } from './independent-contractor-agreement.component';
import { IndependentContractorAgreementRoutingModule } from './independent-contractor-agreement-routing.module';

@NgModule({
  imports: [
    CommonModule,
    IndependentContractorAgreementRoutingModule,
    FormsModule,
    AppMaterialModule,
    SharedModule,
    TextMaskModule,
    MatDialogModule,
  ],
  declarations: [IndependentContractorAgreementComponent],
  exports: [IndependentContractorAgreementComponent],
  providers: [
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: [] },
  ],
})
export class IndependentContractorAgreementModule {}
